
import { addAddress2 } from '@/api/jfhl.js'
import { getAddressDefault, addAddress, editAddress } from '@/api/user.js'
import descStar from '@/assets/jfcj/desc_star.png'
import descBottom from '@/assets/jfcj/bottom_bg.png'
import AddressPicker from '@/views/components/address-picker2'
import HeaderDialog from './header-dialog'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
XDialog,
AddressPicker,
HeaderDialog
},
props: ['lotid'],
data () {
return {
showAddress: false,
desc_star: descStar,
desc_bottom: descBottom,
partyid: this.$route.params.partyid,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: ''
},
addressValue: [],
provinceid: '',
countyid: '',
cityid: '',
addressid: '',
isAddress: true
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
addressValue: {
handler: function (val) {
this.provinceid = val[0]
this.cityid = val[1]
this.countyid = val[2]
},
deep: true
}
},
mounted () { },
methods: {
showDialog () {
this.getaddress()
this.showAddress = true
},
getaddress () {
getAddressDefault({
userid: this.userid,
accountid: this.accountid
}).then(data => {
if (data.returnValue !== '') {
this.isAddress = true
this.addressid = data.returnValue.ID
this.personObj.NAME = data.returnValue.NAME
this.personObj.MOBILE = data.returnValue.MOBILE
this.personObj.ADDRESS = data.returnValue.ADDRESS
this.provinceid = data.returnValue.PROVINCEID
this.cityid = data.returnValue.CITYID
this.countyid = data.returnValue.COUNTYID
this.$set(this.addressValue, 0, data.returnValue.PROVINCEID.toString())
this.$set(this.addressValue, 1, data.returnValue.CITYID.toString())
this.$set(this.addressValue, 2, data.returnValue.COUNTYID.toString())
} else {
this.isAddress = false
this.addressValue.splice(0, this.addressValue.length)
}
})
},

sumbit () {
if (this.personObj.NAME === '') {
this.$vux.toast.text('请填写姓名！', 'middle')
return false
}
if (this.personObj.MOBILE === '') {
this.$vux.toast.text('请填写手机号码！', 'middle')
return false
}
if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对！', 'middle')
return false
}
if (this.addressValue.length === 0) {
this.$vux.toast.text('请选择所在省地市！', 'middle')
return false
}
if (this.personObj.ADDRESS === '') {
this.$vux.toast.text('请填写详细地址！', 'middle')
return false
}
addAddress2({
userid: this.accountid,
partyid: this.partyid,
linkman: this.personObj.NAME,
phone: this.personObj.MOBILE,
address: this.personObj.ADDRESS,
provinceid: this.provinceid,
cityid: this.cityid,
countyid: this.countyid
}).then(res => {
if (res.success) {
if (!this.isAddress) {
this.address()
} else {
this.edit()
}
}
})
},
address () {
addAddress({
accountid: this.accountid,
openid: this.userid,
address: this.personObj.ADDRESS,
isdefault: 1,
provinceid: this.provinceid,
cityid: this.cityid,
countyid: this.countyid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE
}).then(res => {
this.$vux.toast.text('地址添加成功！', 'middle')
this.showAddress = false
}).catch(err => {
this.$vux.toast.text(err.msg, 'middle')
this.showAddress = false
})
},
edit () {
editAddress({
addressid: this.addressid,
accountid: this.accountid,
openid: this.userid,
address: this.personObj.ADDRESS,
isdefault: 1,
provinceid: this.provinceid,
cityid: this.cityid,
countyid: this.countyid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE
}).then(res => {
this.$vux.toast.text('地址修改成功！', 'middle')
this.showAddress = false
}).catch((err) => {
this.$vux.toast.text(err.msg, 'middle')
this.showAddress = false
})
},
onblur () {
window.scrollTo(0, document.documentElement.clientHeight)
}
}
}
